export const getPlatformFilterValue = (selectedPlatforms: string[]): string | null => {
  // if both platforms are selected, return null
  if (selectedPlatforms.length === 2) {
    return null;
  }

  // otherwise, return the selected platform
  return getFilterValue(selectedPlatforms);
};

export const getFilterValue = (filterValue: string | string[] | null | undefined): string | null => {
  if (!filterValue) return null;

  const array = Array.isArray(filterValue) ? filterValue : [filterValue];

  if (array.includes('all')) return null;

  return array[0] ?? null;
};

export const hasFilterActive = (filterArray: string[]) => {
  return filterArray.length && !filterArray.includes('all');
};

export const getMultipleFilterValues = (filterArray: string[]) => {
  return filterArray.length >= 1 && !filterArray.includes('all') ? filterArray : undefined;
};
